import React from 'react';
import clsx from 'clsx';

import './styles.scss';

export default function QueryReadout({ modifier, children }) {
  return (
    <div className={clsx('query-readout', modifier && `query-readout--${modifier}`)}>
      {children}
    </div>
  );
}

export function PoliciesQueryReadout({ policyType, branchPolicyType, year }) {
  const type = policyType.model.id ? policyType.model.name : 'All';

  return (
    <QueryReadout modifier="policies">
      {branchPolicyType && branchPolicyType !== policyType ? <><em>{branchPolicyType.model.name}</em>, </> : null}
      <em>{type} </em>
      <span>policies </span>
      <span>active in </span>
      <em>{year.model.name.toString().toLowerCase()} </em>
    </QueryReadout>
  );
}

export function TradeQueryReadout({ query }) {
  const units = query.units === 'value' ? 'value (US $)' : 'weight';

  return (
    <QueryReadout modifier="trade">
      <em>{query.exporter.model.name} </em>
      <span>exporting </span>
      <em>{query.category.model.name} </em>
      <span>to </span>
      <em>{query.importer.model.name}</em>
      <span>, </span>
      <span> in </span>
      <em>{query.year.id} </em>
      <span>by </span>
      <em>{units}</em>
    </QueryReadout>
  );
}
